import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

const StaffListPage = lazyWithRetry(() => import('@erp/staff/pages/StaffListPage.tsx'));
const RoleManagementPage = lazyWithRetry(() => import('../pages/RoleManagementPage.tsx'));

const listNode: ComponentPage = {
  component: StaffListPage,
};

const rolesNode: ComponentPage = {
  component: RoleManagementPage,
};

const staffRoutes: ComponentOrMapping = {
  erp: {
    staff: {
      '': listNode,
    },
    configuration: {
      roles: rolesNode,
    },
  },
};

export default staffRoutes;
